import { render, staticRenderFns } from "./intervention-form-data.component.vue?vue&type=template&id=0653ba39&"
import script from "./intervention-form-data.component.vue?vue&type=script&lang=ts&"
export * from "./intervention-form-data.component.vue?vue&type=script&lang=ts&"
import style0 from "./intervention-form-data.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "intervention-form-data.component.vue"
export default component.exports